/**
 * Converts a boolean to a Uint8Array.
 * True is encoded as 1, false as 0.
 *
 * @param value - The boolean to convert
 * @returns A Uint8Array with a single byte (0 or 1)
 *
 * @example
 * ```ts
 * import { BooleanToUint8 } from "@pdfking/tfunc"
 *
 * const trueBytes = BooleanToUint8(true);
 * console.log(trueBytes); // Uint8Array [1]
 *
 * const falseBytes = BooleanToUint8(false);
 * console.log(falseBytes); // Uint8Array [0]
 *
 * // Use for hashing
 * const hash = await UInt8Hash([BooleanToUint8(isActive)]);
 * ```
 */
export const BooleanToUint8 = (value: boolean): Uint8Array =>
  new Uint8Array([value ? 1 : 0])
